import actionTypes from './actionTypes';
import defaults from './defaults';

const reducer = (state = defaults, action) => {
    switch (action.type) {
        case actionTypes.HYDRATE_APPLIED_REPORT:
        case actionTypes.SET_APPLIED_REPORT:
            return action.payload;
        case actionTypes.SET_REPORT_AND_FILTERS:
            return action.report;
        default:
            return state;
    }
};

export default reducer;
